exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NotificationConfigCard {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(119, 119, 119, 0.75);\r\n\tmargin-bottom: 15px;\r\n\tpadding: 10px;\r\n}\r\n\r\n.NotificationConfigCard > header {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: row-reverse;\r\n\t    flex-direction: row-reverse;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/view/CriticalValueNotifications/NotificationConfigCard/NotificationConfigCard.css
// module id = 710
// module chunks = 0